import { HttpClient } from '../utils/httpClient';

const PATH = {
    getLogs: '/root/ocpi/logs',
};

const GetLogs = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getLogs}`, { params }).then(callback).catch(error).finally(next);
};

export const RootOcpiService = {
    GetLogs,
};
